import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DocumentTypeCard = ({ 
  type, 
  title, 
  description, 
  requirements, 
  status, 
  onUpload, 
  onView,
  uploadedFile 
}) => {
  const getStatusIcon = () => {
    switch (status) {
      case 'completed':
        return { name: 'CheckCircle', color: 'text-success' };
      case 'pending':
        return { name: 'Clock', color: 'text-warning' };
      case 'rejected':
        return { name: 'XCircle', color: 'text-error' };
      default:
        return { name: 'Upload', color: 'text-muted-foreground' };
    }
  };

  const statusIcon = getStatusIcon();

  return (
    <div className="bg-card border border-border rounded-lg p-6 hover:shadow-md transition-shadow duration-200">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center space-x-3">
          <div className={`w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center`}>
            <Icon name="FileText" size={20} className="text-primary" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-foreground">{title}</h3>
            <p className="text-sm text-muted-foreground">{description}</p>
          </div>
        </div>
        <div className="flex items-center space-x-2">
          <Icon name={statusIcon?.name} size={20} className={statusIcon?.color} />
          <span className={`text-sm font-medium capitalize ${statusIcon?.color}`}>
            {status || 'Required'}
          </span>
        </div>
      </div>
      <div className="mb-4">
        <h4 className="text-sm font-medium text-foreground mb-2">Requirements:</h4>
        <ul className="space-y-1">
          {requirements?.map((req, index) => (
            <li key={index} className="flex items-center space-x-2 text-sm text-muted-foreground">
              <Icon name="Check" size={14} className="text-success flex-shrink-0" />
              <span>{req}</span>
            </li>
          ))}
        </ul>
      </div>
      {uploadedFile && (
        <div className="mb-4 p-3 bg-muted rounded-lg">
          <div className="flex items-center space-x-3">
            <Icon name="File" size={16} className="text-muted-foreground" />
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-foreground truncate">{uploadedFile?.name}</p>
              <p className="text-xs text-muted-foreground">
                {uploadedFile?.size} • Uploaded {uploadedFile?.uploadDate}
              </p>
            </div>
            {status === 'completed' && (
              <Button
                variant="ghost"
                size="sm"
                onClick={() => onView(type)}
                iconName="Eye"
                iconPosition="left"
                iconSize={14}
              >
                View
              </Button>
            )}
          </div>
        </div>
      )}
      <div className="flex space-x-3">
        <Button
          variant={status === 'completed' ? 'outline' : 'default'}
          onClick={() => onUpload(type)}
          iconName="Upload"
          iconPosition="left"
          iconSize={16}
          className="flex-1"
        >
          {status === 'completed' ? 'Replace' : 'Upload'}
        </Button>
        {status === 'rejected' && (
          <Button
            variant="ghost"
            size="sm"
            iconName="Info"
            iconSize={16}
          >
            Why rejected?
          </Button>
        )}
      </div>
    </div>
  );
};

export default DocumentTypeCard;